import { createContext, ReactElement, useReducer } from "react"
import artistsReducer, { initialArtistsState } from "../store/reducers/artists"
import axios from "utils/axios"
import { FETCH_ARTIST_DETAIL, FETCH_ARTIST_SOCIAL_LINKS, FETCH_ARTISTS } from "../store/reducers/actions"
import { mapPaginatedDataToCamelCase, mapToCamelCase } from "../utils/caseTransformation"
import { PaginatedData } from "types/root"
import { getFilterText } from "../utils"
import { Artist, ArtistsContextType, ArtistSocialLink } from "../types/artists"

const ArtistsContext = createContext<ArtistsContextType | null>(null)

export const ArtistsProvider = ({ children }: { children: ReactElement }) => {
  const [state, dispatch] = useReducer(artistsReducer, initialArtistsState)

  const fetchArtists = async (limit: number, offset: number, filter?: any, orderBy?: string, isDetail?: boolean) => {
    const response = await axios(
      `/artists/list_advance/?limit=${limit}&offset=${offset}${getFilterText({ ...filter, advanceFilter: undefined })}${
        orderBy ? `&order_by=${orderBy}` : ""
      }`,
      { method: "post", data: { advanceFilter: filter.advanceFilter } }
    )

    if (isDetail) {
      dispatch({
        type: FETCH_ARTIST_DETAIL,
        payload: { ...state, paginatedArtistDetail: mapPaginatedDataToCamelCase<PaginatedData<Artist>>(response.data) }
      })
      return
    }

    dispatch({
      type: FETCH_ARTISTS,
      payload: { ...state, paginatedArtists: mapPaginatedDataToCamelCase<PaginatedData<Artist>>(response.data) }
    })
  }

  const fetchArtistSocialLinks = async (artistId: number) => {
    const response = await axios(`/artists/social_links/?artist_id=${artistId}`, { method: "get" })

    dispatch({
      type: FETCH_ARTIST_SOCIAL_LINKS,
      payload: { ...state, artistSocialLinks: mapToCamelCase<ArtistSocialLink>(response.data.result) }
    })
  }

  return (
    <ArtistsContext.Provider value={{ ...state, fetchArtists, fetchArtistSocialLinks }}>
      {children}
    </ArtistsContext.Provider>
  )
}

export default ArtistsContext
